import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useCampaignComparable from '@hooks/useCampaignComparable'

import { CampaignComparableModel } from '@models/types'

import SearchComparablesIcon from '../../assets/search_exact_match.svg'

interface SearchComparablesProps {
  campaignComparable: CampaignComparableModel,
}

const SearchComparables = (props: SearchComparablesProps) => {
  const { campaignComparable } = props

  const {
    callbacks: {
      searchCampaignComparables,
    },
  } = useCampaignComparable(campaignComparable)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        padding: 'large',
      }}
      onClick={() => searchCampaignComparables()}
      showAngleIcon
    >
      <Image backgroundSize="contain" url={SearchComparablesIcon} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Search Exact Match</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Find a specific property</Text>
      </Box>
    </ListItem>
  )
}

export default SearchComparables
